import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  ApiServices,
  ApiServiceTypes,
  DefaultQueryParams,
  iframeService,
  parseQuery,
  TranslationContext,
} from '@pascal/pascal-core';
import { useAssetsLoadedState } from '../../module/hooks/useAssetsLoadedState';
import { soundService } from '../../module/services/SoundService';
import { AppDefaultValuesEnum } from '../../enums/AppDefaultValues';

export let bodyRef;
export let translations = {};

export const LoadingContainer = observer(({ children }) => {
  const { assetsIsLoaded } = useAssetsLoadedState(bodyRef);
  const [soundIsLoaded, setSoundIsLoaded] = useState(false)

  const query = parseQuery(window.location.search);

  const lang = query[DefaultQueryParams.Culture] || AppDefaultValuesEnum.LANGUAGE;
  const partnerId = query[DefaultQueryParams.PartnerId];

  const fetchTranslation = useCallback(async () => {
    const response = await ApiServices.get(ApiServiceTypes.TranslationService).getTranslations({
      applicationId: AppDefaultValuesEnum.APPLICATION_ID,
      code: lang,
      partnerId,
    });
    const { data } = response;
    const { result: responseResult } = data;
    translations = data.result

    if (!responseResult) {
      const {
        data: { result },
      } = await ApiServices.get(ApiServiceTypes.TranslationService).getTranslations({
        applicationId: AppDefaultValuesEnum.APPLICATION_ID,
        code: AppDefaultValuesEnum.LANGUAGE,
        partnerId,
      });
      translations = result;
    }
  }, [lang, partnerId]);

  const fetchSound = useCallback(async () => {
    await soundService.init({ language: lang }).then(() => setSoundIsLoaded(true));
  }, [lang]);


  useEffect(() => {
    bodyRef = document.querySelector('body');
    (async function () {
      await fetchTranslation();
      await fetchSound();
    })();
  }, [fetchSound, fetchTranslation]);

  useEffect(() => {
   if(assetsIsLoaded && Object.values(translations) && soundIsLoaded) {
     iframeService.sendLoadedState()
   }
  }, [assetsIsLoaded, translations, soundIsLoaded]);

  return (
    <TranslationContext.Provider value={translations}>
      {children}
    </TranslationContext.Provider>
  );
});
